import { FontAwesome } from "@app/shared/icons/qesIcons";
import PageHeader from "@app/shared/PageHeader";
import PageHeaderRight from "@app/shared/PageHeaderRight";
import { memo } from "react";
import { useParams } from "react-router-dom";

function nonMemoProviderNetworkImportHeader() {
  const { networkId } = useParams<{ networkId?: string }>();

  return (
    <PageHeader title="Provider Network Import" disableHR={true} iconName={FontAwesome.UserMd}>
      <PageHeaderRight>
        <div className="page-title-bar">
          <div className="ms-auto">
            <a href={`${window.uiEndpoint}/data/providersets/${networkId}`} className="qes-button qes-button-primary mt-1 mr5" type="button">Provider Network Summary</a>
          </div>
        </div>
      </PageHeaderRight>
    </PageHeader>
  );
}

export const ProviderNetworkImportHeader = memo(nonMemoProviderNetworkImportHeader);
